export default "#### Pay the full amount of your car\n\nComplete your payment right now using a credit or debit card. Card fees do apply.\n";